export const LanguageKeys = ['en', 'ko', 'ja'] as const;

export type Language = {
  label: string;
  lang: (typeof LanguageKeys)[number];
};

export const SupportedLanguages: Language[] = [
  { label: '한국어', lang: 'ko' },
  { label: 'English', lang: 'en' },
  { label: '日本語', lang: 'ja' },
] as const;
